"use strict";
export function useDeviceInsets() {
  return {
    top: 0,
    bottom: 0,
    left: 0,
    right: 0
  };
}
